import { render, staticRenderFns } from "./collectAuction.vue?vue&type=template&id=13e24504&scoped=true&"
import script from "./collectAuction.vue?vue&type=script&lang=js&"
export * from "./collectAuction.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./collectAuction.vue?vue&type=style&index=0&id=13e24504&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "13e24504",
  "53e13773"
  
)

export default component.exports